import { StoreAsset } from '~/constants/stores';

export enum StoreConnectActionKeys {
  START_STORE_CONNECT = 'START_STORE_CONNECT',
  STORE_CONNECT_URL_FETCH = 'STORE_CONNECT_URL_FETCH',
  STORE_CONNECT_URL_FETCH_SUCCESS = 'STORE_CONNECT_URL_FETCH_SUCCESS',
  STORE_CONNECT_URL_FETCH_ERROR = 'STORE_CONNECT_URL_FETCH_ERROR',
  STORE_CONNECT_DISMISS_ERROR = 'STORE_CONNECT_DISMISS_ERROR',
}

export function startStoreConnect(
  storeSelection: StoreAsset,
  readyForUrl: boolean,
  shippoLocation: string,
  params?: object,
) {
  return <const>{
    type: StoreConnectActionKeys.START_STORE_CONNECT,
    payload: {
      params,
      readyForUrl,
      shippoLocation,
      storeSelection,
    },
  };
}

export function fetchStoreConnectUrl(params?: object) {
  return <const>{
    type: StoreConnectActionKeys.STORE_CONNECT_URL_FETCH,
    payload: {
      params,
    },
  };
}

export function fetchStoreConnectUrlSuccess(redirectUrl: string, queryString: string) {
  return <const>{
    type: StoreConnectActionKeys.STORE_CONNECT_URL_FETCH_SUCCESS,
    payload: {
      redirectUrl,
      queryString,
    },
  };
}

export function fetchStoreConnectUrlError(error: string) {
  return <const>{
    type: StoreConnectActionKeys.STORE_CONNECT_URL_FETCH_ERROR,
    payload: {
      error,
    },
  };
}

export function dismissStoreConnectError() {
  return <const>{
    type: StoreConnectActionKeys.STORE_CONNECT_DISMISS_ERROR,
  };
}

export type StoreConnectActionTypes =
  | ReturnType<typeof startStoreConnect>
  | ReturnType<typeof fetchStoreConnectUrl>
  | ReturnType<typeof fetchStoreConnectUrlSuccess>
  | ReturnType<typeof fetchStoreConnectUrlError>
  | ReturnType<typeof dismissStoreConnectError>;
